<template>
    <PatientLayout class="faq-page" :contents="contents" />
</template>

<script>
import contentData from "@/assets/pages/contents-FAQ.json";
import PatientLayout from '@/views/patients/PatientLayout.vue'

export default {
    components: {
        PatientLayout
    },
    data() {
        return {
            contents: contentData, 
        };
    },
}
</script>